import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Client } from '@df/core/service/client';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';

interface IShortAddress {
    firstname?: string;
    lastname?: string;
    street_1?: string;
    street_2?: string;
    city?: string;
    postcode?: string;
    region?: string;
    country?: string;
}
@Component({
    selector: 'short-address',
    templateUrl: './short-address.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SizeClassDirective, TranslationModule, NgClass]
})
export class ShortAddressComponent {
    /**
     * Title of the address block
     */
    @Input()
    title?: string;
    /**
     * Address
     */
    @Input({
        required: true
    })
    address!: IShortAddress;

    @Input()
    color?: string;

    @Input()
    zipCodeBelow?: boolean;

    client = inject(Client);
}
